import type { CandidateProcess } from '@entities/candidates';
import type { OutgoingChatMessage } from '@packages/chat/react';
import type { CandidateInterviewChatItem } from '../types';
import { getSenderDisplayName } from './getCandidateSenderDisplayName';

export const toServerChatItem = (
  process: CandidateProcess,
  candidateName: string
): CandidateInterviewChatItem => {
  const audioFile =
    process.contentType === 'audio' ? process.file[0] : undefined;

  return {
    key: `server:${process.id}`,
    sender: process.processType === 'from_whats_app' ? 'other' : 'self',
    senderName:
      process.processType === 'from_whats_app'
        ? candidateName
        : getSenderDisplayName(process.sender),
    time: process.createdAt,
    contentType: process.contentType,
    message: process.content,
    status: process.status,
    transcription: process.transcription,
    fileName: audioFile?.name,
    audioUrl: audioFile?.absolutePath,
    images:
      process.contentType === 'image'
        ? process.file.map(file => ({
            absolutePath: file.absolutePath,
            name: file.name,
          }))
        : undefined,
  };
};

/** A sent message shown with a loader until the server returns it. */
export const toLocalChatItem = (
  message: OutgoingChatMessage
): CandidateInterviewChatItem => ({
  key: `local:${message.clientId}`,
  sender: 'self',
  senderName: getSenderDisplayName(null),
  time: message.createdAt,
  contentType: message.audio ? 'audio' : 'text',
  message: message.text ?? '',
  status: 'pending',
  transcription: null,
  fileName: message.audio?.name,
  audioUrl: message.audio?.url,
});
